import React from 'react';
import { X, Lock, CreditCard } from 'lucide-react';

const FeatureBlockedModal = ({ isOpen, onClose, onRenewClick, daysRemaining }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center">
            <Lock className="h-6 w-6 text-red-500 mr-2" />
            <h3 className="text-lg font-medium text-gray-900">Feature Unavailable</h3>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        
        <div className="mb-6">
          <p className="text-sm text-gray-600 mb-3">
            This feature is currently unavailable because your subscription has expired.
          </p>
          <div className="bg-yellow-50 border border-yellow-200 rounded-md p-3 mb-4">
            <p className="text-sm text-yellow-800">
              <strong>Grace Period:</strong> You have {daysRemaining} day{daysRemaining !== 1 ? 's' : ''} remaining 
              to renew your subscription and restore full access.
            </p>
          </div>
          <p className="text-sm text-gray-600">
            During the grace period, you can:
          </p>
          <ul className="text-sm text-gray-600 mt-2 ml-4 list-disc">
            <li>Access your dashboard</li>
            <li>View existing data</li>
            <li>Manage your subscription</li>
          </ul>
        </div>
        
        <div className="flex space-x-3">
          <button
            onClick={onRenewClick}
            className="flex-1 inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
          >
            <CreditCard className="h-4 w-4 mr-2" />
            Renew Now
          </button>
          <button
            onClick={onClose}
            className="flex-1 inline-flex justify-center items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeatureBlockedModal;
